import {httpPost} from "../libs/http";

export const createWebsiteSetupOrder = (data, onSuccess = null, onFailure = null) => dispatch => {
    httpPost('/billing/orders/website-setup/create/', data, (res) => onSuccess(res), (err) => onFailure(err));
}